import styled from 'styled-components';

export const PhoneVideo = styled.video`
  width: 100%;
  height: 100%;
  transform: scale(1.05);
`;

export const TeaserVideoWrapper = styled.video`
  width: 100%;
  height: auto;
`;


// WEBPACK FOOTER //
// src/app/src/components/Videos/Video.s.ts